var map = {
	"./asset.js": "./src/helpers/asset.js",
	"./document-type.js": "./src/helpers/document-type.js",
	"./importer.js": "./src/helpers/importer.js",
	"./model.js": "./src/helpers/model.js",
	"./project-type.js": "./src/helpers/project-type.js",
	"./renderer.js": "./src/helpers/renderer.js",
	"./transformer.js": "./src/helpers/transformer.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;



//////////////////
// WEBPACK FOOTER
// ./src/helpers nonrecursive \.js$
// module id = 85
// module chunks = 0 1 2 3 4 5 6 7